<div class="container" *ngIf="loadRic">
  <ric-promo-banner></ric-promo-banner>
</div>